<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <!-- <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button> -->

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column fixed :reserve-selection="true" type="selection" width="55" align="center"></el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
                  v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                <!-- <el-button v-else-if="
                    scope.row.status != 1 &&
                      scope.row.status != 2 &&
                      tableAcl.indexOf('Edit') != -1
                  " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button> -->
                <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button> -->
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
      style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>
      <el-table-column fixed :reserve-selection="true" type="selection" width="55" align="center"></el-table-column>

      <el-table-column v-if="isWorkflowTable" label="审批人" width="180" align="center" prop="approverNames">
        <template slot-scope="scope">
          {{ scope.row.approverNames?scope.row.approverNames:'-' }}
        </template>
      </el-table-column>
      <el-table-column prop="statusName" label="审批状态" width="120" v-if="isWorkflowTable">
        <template slot-scope="scope">
          <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
            @success="getData" :tableCode="route.name"></approve-status>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" min-width="100" prop="categoryName"
        label="申请类型"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" min-width="140" prop="typeName" label="自动申领标识"></el-table-column>

      <el-table-column :show-overflow-tooltip="true" min-width="170" prop="no" label="单号">
        <template slot-scope="scope">
          <span>
            <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" width="170">
        <template slot-scope="scope">
          {{ scope.row.createdTime?parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}"):'-' }}
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" min-width="100" prop="applyUserName"
        label="申请人"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" min-width="100" prop="applyDeptName"
        label="申请科室"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" min-width="140" prop="warehouseName"
        label="申请库房"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" min-width="140" prop="oneLevelWarehouseName"
        label="目标库房"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" min-width="120" prop="totalNumber"
        label="申请总数量"></el-table-column>

      <el-table-column prop="operation" fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
          <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
            v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
          <!-- <el-button v-else-if="
              scope.row.status != 1 &&
                scope.row.status != 2 &&
                tableAcl.indexOf('Edit') != -1
            " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button> -->
          <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    </div>
 
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import { RemoveAutoPurchaseApply, GetAutoPurchaseApplys } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  ApproveStatusOptions,
  AutoPurchaseApplyCategoryOptions,
  AutoPurchaseApplyOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      transferProps: [],
      GetDatasAction: GetAutoPurchaseApplys,
      RemoveAction: RemoveAutoPurchaseApply,
      // PrintAction: GetPrintData,
      editPath: "auto-purchase-apply-edit",

      ApproveStatusOptions: ApproveStatusOptions,
      AutoPurchaseApplyCategoryOptions: AutoPurchaseApplyCategoryOptions,
      AutoPurchaseApplyOptions: AutoPurchaseApplyOptions,
      filterOptions: [
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
        {
          name: "单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "供应商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "生产厂家",
          type: "input",
          code: "manufacturerName",
          // filterMethod: this.getManufacturers,
          // data: [],
        },
        {
          name: "目标库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getOneLevelWarehouses,
          data: [],
        },
        {
          name: "自动申领标识",
          type: "select",
          code: "type",
          data: AutoPurchaseApplyOptions,
        },
        {
          name: "申请类型",
          type: "select",
          code: "category",
          data: AutoPurchaseApplyCategoryOptions,
        },
   
        {
          name: "申请科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        // {
        //   name: "日期范围",
        //   type: "date",
        //   code: "date",
        // },
      ],
    };
  },
  methods: {
 
  },
  created () {
    if (this.$route.params && this.$route.params.approveId) {
      this.query.approveId = this.$route.params.approveId;
    }
  },
  mounted () {
    this.filterOptions[0].hidden = !this.isWorkflowTable;
    // if (this.$route.params && this.$route.params.approveId) {
    //   this.$refs["selectFilter"].query.approveId = this.$route.params.approveId
    // }
  },
};
</script>

<style lang="scss" scoped></style>
